import { ArrowRightOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Spin } from "antd";
import { RubrosEvaluacion } from "../Rubros/RubrosEvaluacion";
import { ResumenEvaluacion } from "../../shared/ResumenEvaluacion";
import styles from "../../shared/Evaluaciones.module.css";

export function FormularioEvaluacion({ modelo }) {
  const {
    form, initialValues, operadores, asistenciaID, servicioConsultado,
    cargandoInicial, errorInicial,
    operador, cargandoContexto, errorContexto, contextoListo, formularioListo,
    plantillas, supervisores,
    rubros, cargandoRubros, errorRubros, respuestas,
    respondidos, totalRubros, completo, guardando, puedeGuardar,
    responderRubro, cambiarServicio, buscarServicio, cambiarOperador, guardar,
  } = modelo;

  return (
    <Form form={form} layout="vertical" onFinish={guardar} initialValues={initialValues} disabled={guardando}>
      {errorInicial && <p className={styles.error} role="alert">{errorInicial}</p>}
      {!errorInicial && (
        <div className={styles.contextGrid}>
          <div className={styles.selector}>
            <Form.Item
              name="asistenciaID"
              label="Servicio"
              rules={[{ required: true, whitespace: true, message: "Escribe un servicio" }]}
            >
              <Input
                aria-label="Servicio"
                placeholder="Escribe el folio del servicio"
                disabled={cargandoInicial || guardando}
                onChange={cambiarServicio}
                onPressEnter={event => event.preventDefault()}
                suffix={
                  <Button
                    type="text"
                    size="small"
                    htmlType="button"
                    aria-label="Buscar servicio"
                    icon={<SearchOutlined />}
                    onClick={buscarServicio}
                    loading={cargandoContexto}
                    disabled={cargandoInicial || guardando || !asistenciaID?.trim()}
                  />
                }
              />
            </Form.Item>
          </div>
          <div className={styles.selector}>
            <Form.Item
              name="usuarioEmpleadoID"
              label="Operador"
              rules={[{ required: true, message: "Selecciona un operador" }]}
            >
              <Select
                aria-label="Operador"
                showSearch
                optionFilterProp="label"
                placeholder="Selecciona un operador"
                disabled={!servicioConsultado || cargandoContexto || Boolean(errorContexto) || guardando}
                onChange={cambiarOperador}
                options={operadores.map(item => ({ value: item.usuarioID, label: item.usuarioNombre }))}
              />
            </Form.Item>
          </div>
          <div className={styles.selector}>
            <Form.Item
              name="evaluacionID"
              label="Plantilla"
              rules={[{ required: true, message: "Selecciona una plantilla" }]}
            >
              <Select
                aria-label="Plantilla"
                placeholder="Selecciona una plantilla"
                disabled={!contextoListo || guardando}
                options={plantillas.map(item => ({ value: item.id, label: item.nombre }))}
              />
            </Form.Item>
          </div>
        </div>
      )}
      {errorContexto && <p className={styles.error} role="alert">{errorContexto}</p>}
      {formularioListo && (
        <>
          <ResumenEvaluacion
            className={styles.summaryThree}
            items={[
              ["Empleado", operador.usuarioNombre],
              ["Servicio", asistenciaID],
              ["Plantilla", modelo.plantilla.nombre],
            ]}
          />
          <div className={styles.formGrid}>
            <Form.Item
              name="fechaEvaluacion"
              label="Fecha de evaluación"
              rules={[{ required: true, message: "Indica la fecha" }]}
            >
              <Input type="date" />
            </Form.Item>
            <Form.Item name="usuarioAnalistaNombre" label="Analista">
              <Input readOnly />
            </Form.Item>
            <Form.Item name="tipoMonitoreo" label="Tipo de monitoreo" rules={[{ required: true }]}>
              <Select
                options={["A día vencido", "En tiempo real"].map(value => ({ value, label: value }))}
              />
            </Form.Item>
            <Form.Item
              name="usuarioSupervisorID"
              label="Supervisor"
              rules={[{ required: true, message: "Selecciona un supervisor" }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                placeholder="Selecciona un supervisor"
                options={supervisores.map(item => ({ value: item.usuarioID, label: item.nombre }))}
              />
            </Form.Item>
            <Form.Item
              name="etiquetaLlamada"
              label="Etiqueta de llamada"
              rules={[{ required: true, whitespace: true, message: "Indica la etiqueta de llamada" }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="duracion"
              label="Duración"
              rules={[{ required: true, whitespace: true, message: "Indica la duración" }]}
            >
              <Input placeholder="15m" />
            </Form.Item>
          </div>
          {cargandoRubros && <Spin />}
          {errorRubros && <p className={styles.error} role="alert">{errorRubros}</p>}
          {rubros.length > 0 && (
            <RubrosEvaluacion
              rubros={rubros}
              respuestas={respuestas}
              onChange={responderRubro}
            />
          )}
          <div className={styles.notes}>
            <Form.Item name="puntosAMejorar" label="Puntos a mejorar">
              <Input.TextArea rows={4} placeholder="Acciones concretas para el siguiente monitoreo…" />
            </Form.Item>
            <Form.Item name="comentarios" label="Comentarios">
              <Input.TextArea rows={4} placeholder="Observaciones generales de la evaluación…" />
            </Form.Item>
          </div>
          <footer className={styles.savebar}>
            <div>
              <span className={styles.label}>RESPUESTAS</span>
              <strong>{respondidos} / {totalRubros}</strong>
            </div>
            <div>
              <span className={styles.label}>PENALIZACIÓN</span>
              <strong>—</strong>
            </div>
            <div>
              <span className={styles.label}>{completo ? "CALIFICACIÓN" : "PUNTAJE PARCIAL"}</span>
              <strong>—</strong>
            </div>
            <Button type="primary" htmlType="submit" loading={guardando} disabled={!puedeGuardar}>
              Guardar evaluación <ArrowRightOutlined />
            </Button>
          </footer>
        </>
      )}
    </Form>
  );
}
